import { useTranslation } from 'react-i18next';

import { LanguageSelector } from '@/components/Elements/LanguageSelector/LanguageSelector';

export const PublicCleanFooter = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-7xl mx-auto mt-10 mb-16 px-5 text-center md:text-left">
      <div className="flex gap-2.5 items-center">
        <p>
          {`${t('PublicFooter.copyright')} `}
          {`${t('PublicFooter.certificated')} `}
          <a
            rel="nofollow"
            href={t('LegalTerms.privacyPolicyURL')}
            title={t('LegalTerms.privacyPolicy')}
          >
            {` ${t('PublicFooter.privacy')}`}
          </a>
          {` ${t('common.and')} `}
          <a rel="nofollow" href={t('LegalTerms.termsURL')} title={t('LegalTerms.terms')}>
            {t('PublicFooter.terms')}
          </a>
          .
        </p>
        <LanguageSelector placement="topStart" />
      </div>
    </div>
  );
};
